<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import Icon from "./Icon.vue";
import { stepWhen } from "../composables/nextSteps";
import { vTooltip } from "../directives/tooltip";
import { t } from "../i18n";

/**
 * Beside the window's clock: when the assistant follows up if the contact stays quiet
 * ("Retomada hoje às 18:45", decision 0044), with who and which of how many in its tip.
 */
const props = defineProps<{
  at: string;
  n: number;
  of: number;
  name: string;
}>();
const now = ref(new Date());
let timer: ReturnType<typeof setInterval> | undefined;
onMounted(() => {
  timer = setInterval(() => (now.value = new Date()), 60_000);
});
onBeforeUnmount(() => clearInterval(timer));
const when = computed(() => stepWhen(props.at, now.value));
</script>
<template>
  <span
    class="window-chip follow-up-chip"
    v-tooltip="t('inbox.next.chip_tip', { name, n, of, when })"
  >
    <Icon name="refresh" :size="14" />
    {{ t("inbox.next.chip", { when }) }}
  </span>
</template>
